import { useCallback } from 'react';
import { Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material';
import { DeleteRounded } from '@mui/icons-material';
import { partial } from 'lodash';

import { useDeleteCopyCapabilityMutation } from 'src/hooks/ObjectHooks';
import { SpaceGlassContainerBase } from 'src/components/SpaceGlassControl';
import { ModalHeader } from 'src/pages/Shared/ModalSpaceGlass';
import { Capability } from 'src/types';

interface IModalRemoveUserFromShareProps {
  open: boolean;
  show: (show: boolean) => void;
  capability: Capability | null | undefined;
}

export const ModalRemoveUserFromShare = ({
  open,
  show,
  capability,
}: IModalRemoveUserFromShareProps) => {
  const deleteCopyCapabilityMutation = useDeleteCopyCapabilityMutation();
  const hide = partial(show, false);

  const deleteItem = useCallback(() => {
    if (capability) {
      deleteCopyCapabilityMutation.mutate({ id: capability.id });
    }
    hide();
  }, [deleteCopyCapabilityMutation, capability, hide]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={hide}
      PaperComponent={SpaceGlassContainerBase}
    >
      <ModalHeader
        title="Are You Sure?"
        onClose={hide}
        icon={<DeleteRounded />}
      />
      <DialogContent>
        <Typography variant="body1">
          <b>{capability?.userEmail}</b> will no longer have access.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          type="button"
          onClick={hide}
        >
          CANCEL
        </Button>
        <Button
          color="error"
          variant="contained"
          onClick={deleteItem}
          aria-label="Delete Item"
        >
          Remove User
        </Button>
      </DialogActions>
    </Dialog>
  );
};
